// extracted by mini-css-extract-plugin
module.exports = {"text":"SpectrumHeader_text__Q3u8w"};